import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class AboutHome extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            content:this.props.content, 
        }
        

    }

    componentDidMount()
    {  
         
        if(this.props.content && this.state.loading === 1)
        {
             this.setState({loading:0}); 

              
        }
        
        
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
          
    return (

         
    <div class="section-full p-t80 p-b50 bg-white">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-5 col-md-8 m-b30">
                            <div class=" ">
                               <img src={this.state.content[2]['image']} alt={this.state.content[2]['title']}  class="img-responsive" />
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-12 m-b30">
                            <div class="section-head text-left">
                                <h2 class="text-uppercase">{this.state.content[2]['title']}</h2>
                                <div class="wt-separator-outer">
                                    <div class="wt-separator style-square">
                                        <span class="separator-left site-bg-primary"></span>
                                        <span class="separator-right site-bg-primary"></span>
                                    </div>
                                </div>
                                 <div dangerouslySetInnerHTML={{ __html: this.state.content[2].description }} />  
								<Link to={base_url+`about-us`} class="site-button text-uppercase">Read More</Link>
                            </div>
                            
                    </div>
                </div>
            </div>   
      </div>

       
    );
}

}

export default AboutHome;